export const MAX_NUMBER_INPUT_VALUE = 2 ** 31 - 1;
